import { StatusChip } from '@/design/components'
import { cn } from '@/lib/cn'

/**
 * Elementy sterujące ekranu „Moduły i widoczność" — lokalne dla modułu admin.
 */

export interface EnvStateProps {
  /** Stan z `MODULES_ENABLED`. */
  on: boolean
  label: string
}

/**
 * Stan „W kancelarii" — WYŁĄCZNIE do odczytu: włączanie modułów jest decyzją
 * środowiskową (CONTRACTS.md §0.2) i nie da się jej zmienić z UI. Świadomie NIE jest to
 * przełącznik — element sterujący sugerowałby akcję, której panel nie wykonuje.
 */
export function EnvModuleState({ on, label }: EnvStateProps) {
  const title = 'Konfiguracja w zmiennych środowiskowych (MODULES_ENABLED) — tylko odczyt'
  return (
    <StatusChip variant={on ? 'success' : 'neutral'} size="sm" title={title}>
      <LockIcon />
      {on ? 'włączony' : 'wyłączony'}
      <span className="sr-only">{` — ${label}, stan tylko do odczytu`}</span>
    </StatusChip>
  )
}

/** Kłódka — sygnał „tego nie zmienisz w panelu". */
function LockIcon() {
  return (
    <svg aria-hidden viewBox="0 0 12 12" className="h-[11px] w-[11px] shrink-0 fill-none stroke-current">
      <rect x="2.4" y="5.2" width="7.2" height="5.4" rx="1.1" strokeWidth="1.2" />
      <path d="M4.2 5.2V3.9a1.8 1.8 0 0 1 3.6 0v1.3" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  )
}

export interface VisibilityCheckboxProps {
  checked: boolean
  disabled?: boolean
  title?: string
  label: string
  onChange: (checked: boolean) => void
}

/** Kwadratowy checkbox macierzy widoczności (granatowy „✓" na zaznaczeniu). */
export function VisibilityCheckbox({
  checked,
  disabled = false,
  title,
  label,
  onChange,
}: VisibilityCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      title={title}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'inline-flex h-[16px] w-[16px] items-center justify-center rounded-[2px] border transition-colors duration-fast',
        checked ? 'border-navy-900 bg-navy-900 text-white' : 'border-line bg-card',
        disabled ? 'cursor-not-allowed opacity-45' : 'focus-visible:am-focus focus:outline-none',
        !disabled && !checked && 'hover:border-navy-600',
      )}
    >
      {checked ? (
        <svg aria-hidden viewBox="0 0 10 8" className="h-[7px] w-[9px] fill-none stroke-current">
          <path d="M1 4.2 3.6 6.8 9 1.2" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : null}
    </button>
  )
}
